export default __webpack_public_path__ + "static/media/LoginImage.bacadeba.png";